export default {
  /******************************
   * PRIMARY COLORS
   *****************************/

  /* Dark Blue */
  darkBlue100: '#262e47',
  darkBlue200: '#323d5f',
  darkBlue300: '#3f4c77',
  darkBlue400: '#657092',
  darkBlue500: '#8c94ad',
  darkBlue600: '#b2b7c9',
  darkBlue700: '#d9dbe4',
  darkBlue800: '#ecedf1',

  /* Green */
  green100: '#497144',
  green200: '#62965a',
  green300: '#7abc71',
  green400: '#95c98d',
  green500: '#afd7aa',
  green600: '#cae4c6',
  green700: '#e4f2e3',
  green800: '#f2f8f1',

  /* Pink */
  pink100: '#92374f',
  pink200: '#c34969',
  pink300: '#f45b83',
  pink400: '#f67c9c',
  pink500: '#f89db5',
  pink600: '#fbbdcd',
  pink700: '#fddee6',
  pink800: '#feeff3',

  /* Yellow */
  yellow100: '#957205',
  yellow200: '#c69806',
  yellow300: '#f8be08',
  yellow400: '#f9cb39',
  yellow500: '#fbd86b',
  yellow600: '#fce59c',
  yellow700: '#fef2ce',
  yellow800: '#fef9e6',

  /******************************
   * SECONDARY COLORS
   *****************************/

  /* Warm Gray */
  warmGray100: '#c2bcb6',
  warmGray200: '#dad4cd',
  warmGray300: '#f2ebe4',
  warmGray400: '#f5efe9',
  warmGray500: '#f7f3ef',
  warmGray600: '#faf7f4',
  warmGray700: '#fcfbfa',
  warmGray800: '#fefdfc',

  /* Cool Gray */
  coolGray100: '#c2c2c2',
  coolGray200: '#dadada',
  coolGray300: '#f2f2f2',
  coolGray400: '#f5f5f5',
  coolGray500: '#f6f6f6',
  coolGray600: '#fafafa',
  coolGray700: '#fcfcfc',
  coolGray800: '#fefefe',

  /* Dark Gray */
  darkGray100: '#5f5f5f',
  darkGray200: '#6b6b6b',
  darkGray300: '#777777',
  darkGray400: '#929292',
  darkGray500: '#adadad',
  darkGray600: '#c9c9c9',
  darkGray700: '#e4e4e4',
  darkGray800: '#f1f1f1',

  /* Seafoam */
  seafoam100: '#adb4b7',
  seafoam200: '#c2cbce',
  seafoam300: '#d8e1e5',
  seafoam400: '#e0e7ea',
  seafoam500: '#e8edef',
  seafoam600: '#eff3f5',
  seafoam700: '#f7f9fa',
  seafoam800: '#fbfcfc',

  /******************************
   * TERTIARY COLORS
   *****************************/

  /* Red */
  red100: '#8d1b0a',
  red200: '#a21f0b',
  red300: '#ca270e',
  red400: '#d5523e',
  red500: '#df7d6e',
  red600: '#eaa99f',
  red700: '#f4d4cf',
  red800: '#fae9e7',

  /* Blue */
  blue100: '#074e88',
  blue200: '#08599b',
  blue300: '#0a6fc2',
  blue400: '#3b8cce',
  blue500: '#6ca9da',
  blue600: '#9dc5e7',
  blue700: '#cee2f3',
  blue800: '#e7f1f9',

  /* Charcoal */
  charcoal100: '#272727',
  charcoal200: '#2c2d2c',
  charcoal300: '#373837',
  charcoal400: '#5f605f',
  charcoal500: '#878887',
  charcoal600: '#afafaf',
  charcoal700: '#d7d7d7',
  charcoal800: '#ebebeb',

  /* Teal */
  teal100: '#448a8b',
  teal200: '#4e9e9f',
  teal300: '#61c5c7',
  teal400: '#81d1d2',
  teal500: '#a0dcdd',
  teal600: '#c0e8e9',
  teal700: '#dff3f4',
  teal800: '#eff9f9',
};
